import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { downloadFileUrl } from '@/helpers/download'

// Mixins
import Errors from '@/mixins/Errors'

@Component
export default class Pdf extends Mixins(Errors) {
  @Getter('token') token

  async downloadReportPdf(report, state) {
    try {
      const payload = {
        proovCode: report.proovCode,
        state
      }
      const res = await this.$api.reports.downloadPdf(this.token, payload)
      downloadFileUrl(`${report.proovCode}_${state}.pdf`, res.data.url)
    } catch (error) {
      this.displayErrors(error)
    }
  }
}
